export default "__VITE_PUBLIC_ASSET__3d3a2e27__"